import React from 'react';

const RouteComponent = React.lazy(() => import('./LoginPage'));

export default {
  RouteComponent,
  path: '/login',
  // name is required for React keys in createRoute.js and WrappedRoute.js (Suspense)
  // even though this page doesn't use Redux/sagas. Using name instead of path ensures
  // stable component reconciliation when paths change.
  name: 'login',
};
